



































import { Component, Watch } from "vue-property-decorator";
import RecuperationDiv from "./RecuperationDiv.vue";

@Component
export default class RecuperationDivV3 extends RecuperationDiv {
  // 訪問看護基本療養費（I）（II）のハ と包括型訪問看護療養費の同時算定可能
  private canCoexistWithComprehensive(): boolean {
    return (
      this.receiptVisitRecord.staff_div == 3 &&
      this.receiptVisitRecord.mental_div == 1
    );
  }

  // 療養区分1
  protected disableCheckRemedy1(): boolean {
    let result = false;
    if (
      (this.receiptVisitRecord.comprehensive_flg == 1 ||
        this.receiptVisitRecord.comprehensive_sub_flg == 1) &&
      !this.canCoexistWithComprehensive()
    ) {
      result = true;
    }
    return result;
  }

  // 療養区分2
  protected disableCheckRemedy2(): boolean {
    let result = false;
    if (this.event.visit_record.mental_div != 1) {
      result = true;
    } else if (
      (this.receiptVisitRecord.comprehensive_flg == 1 ||
        this.receiptVisitRecord.comprehensive_sub_flg == 1) &&
      !this.canCoexistWithComprehensive()
    ) {
      result = true;
    }
    return result;
  }

  // 療養区分3
  protected disableCheckRemedy3(): boolean {
    let result = false;
    if (
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  // 療養区分4
  protected disableCheckRemedy4(): boolean {
    let result = false;
    if (
      this.event.visit_record.mental_div == 1 ||
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      result = true;
    }
    return result;
  }

  //療養区分（同一建物内:指示書 && 基本IIで入力可 / 精神指示書 && 基本Ⅲで入力可）左記以外は空にする
  @Watch("receiptVisitRecord.remedy_div") protected handleRemedyDiv() {
    if (!this.isLoaded) {
      return;
    }
    if (
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3) ||
      this.receiptVisitRecord.online_visit_flg == 1 ||
      this.receiptVisitRecord.stay_outside_flg == 1 ||
      this.receiptVisitRecord.remedy_div == 4
    ) {
      this.receiptVisitRecord.times_threeperson_div = 0;
      this.receiptVisitRecord.accompanied_staff_threeperson_div = 0;
    }
  }

  // 登録時にdisabledの項目は0にする
  public clearDisableItem() {
    if (
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      // 「訪問看護基本療養費（I）（II）のハ」(StaffDiv 専門 かつ RemedyDiv ∈ {1, 2}) は包括型と同時算定可能のためクリアしない
      const isException =
        this.canCoexistWithComprehensive() &&
        (this.receiptVisitRecord.remedy_div == 1 ||
          this.receiptVisitRecord.remedy_div == 2);
      if (!isException) {
        this.receiptVisitRecord.remedy_div = 0;
      }
    }
  }
}
